// 首页
export default [

  //业务个人首页
  {
    path: '/homePage',
    name: 'homePage',
    component: () => import( /* webpackChunkName: "homePage" */ '@/views/home/homePage/index'),
    meta: {
      activeMenu: 'homePage', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //业务个人首页
  {
    path: '/salesmanIndex',
    name: 'salesmanIndex',
    component: () => import( /* webpackChunkName: "homePage" */ '@/views/home/homePage/salesmanIndex'),
    meta: {
      activeMenu: 'salesmanIndex', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //采购个人首页
  {
    path: '/purchaseIndex',
    name: 'purchaseIndex',
    component: () => import( /* webpackChunkName: "homePage" */ '@/views/home/homePage/purchaseIndex'),
    meta: {
      activeMenu: 'purchaseIndex', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //配货员首页
  {
    path: '/distributionIndex',
    name: 'distributionIndex',
    component: () => import( /* webpackChunkName: "homePage" */ '@/views/home/homePage/distributionIndex'),
    meta: {
      activeMenu: 'distributionIndex', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //检品员首页
  {
    path: '/testArticleIndex',
    name: 'testArticleIndex',
    component: () => import( /* webpackChunkName: "homePage" */ '@/views/home/homePage/testArticleIndex'),
    meta: {
      activeMenu: 'testArticleIndex', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
]